import type { FeatureCollection } from "geojson";

import dmaGeoJson from "@/assets/maps/dma_light_210.json";

let dmaLabelMap: Record<string, string> | null = null;

export const getDmaLabelMap = (): Record<string, string> => {
  if (dmaLabelMap) return dmaLabelMap;

  const map: Record<string, string> = {};
  for (const feature of (dmaGeoJson as FeatureCollection).features) {
    const props = (feature.properties ?? {}) as Record<string, unknown>;
    const apiKey = props.apiKey as string | undefined;
    const displayName = props.displayName as string | undefined;
    if (apiKey && displayName) map[apiKey] = displayName;
  }

  dmaLabelMap = map;
  return map;
};

const dimensionLabelMaps: Record<string, () => Record<string, string>> = {
  dma: getDmaLabelMap,
};

export const mapDimensionValueLabels = (data: Record<string, unknown>[]): Record<string, unknown>[] => {
  const fields = Object.keys(dimensionLabelMaps);

  return data.map((row) => {
    let mappedRow: Record<string, unknown> | null = null;

    for (const field of fields) {
      const raw = row[field];
      if (typeof raw !== "string") continue;

      const label = dimensionLabelMaps[field]()[raw];
      if (label === undefined || label === raw) continue;

      mappedRow = mappedRow ?? { ...row };
      mappedRow[field] = label;
    }

    return mappedRow ?? row;
  });
};
